export const EWorkerStatus: { [key in string]: string } = {
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE',
    DEAD: 'DEAD',
    ALL: '',
}
